import React from "react"

import { isInPosDevice } from "utils"
import { OrdersGroupPrintButton, OrdersSetAsViewedButton } from "components"
import classes from "./CoFooter.module.scss"

const CoFooter = (props) => {
  const { selectedOrders, setSelectedOrders, setOrders } = props

  const showGroupPrintButton =
    !isInPosDevice()

  return (
    <div className={classes["footer"]}>
      <OrdersSetAsViewedButton
        orderStatus="canceled"
        setOrders={setOrders}
      />

      {
        showGroupPrintButton &&
        <OrdersGroupPrintButton
          selectedOrders={selectedOrders}
          setSelectedOrders={setSelectedOrders}
        />
      }
    </div>
  )
}

export default CoFooter